import { AccountInfo } from "@azure/msal-browser";
import { useMsal } from "@azure/msal-react";
import { useEffect, useState } from "react";
import { loginRequest } from "../config";

export const useUserDetails = () => {
  const { instance, accounts, inProgress } = useMsal();
  const [userData, setUserData] = useState<AccountInfo | null>(null);

  useEffect(() => {
    const acquireToken = async () => {
      if (accounts && accounts?.length > 0 && inProgress === "none") {  
        const request = {
          ...loginRequest,
          account: accounts[0],  
        };

        try {
          const response = await instance.acquireTokenSilent(request);
          setUserData(response.account);
          localStorage.setItem("name", response?.account?.name || "");
        } catch (silentError) {
          console.warn("Silent token acquisition failed, attempting popup:", silentError);

          try {
            const popupResponse = await instance.acquireTokenPopup(request);
            setUserData(popupResponse.account);
            localStorage.setItem("name", popupResponse?.account?.name || "");
          } catch (popupError) {
            console.error("Popup token acquisition failed:", popupError);
          }
        }
      }
    };

    if (inProgress === "none") {
      acquireToken();
    }
  }, [accounts, instance, inProgress]);

  return userData;
};
